import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class OpenAPIFileService {
  constructor(private http: HttpClient) {}

  private getHeaders(headers?: { [key: string]: string }): HttpHeaders {
    return new HttpHeaders({
      ...headers,
    });
  }

  public uploadFile(
    journeyId:string,
    file: File,
    headers?: { [key: string]: string },
  ): Observable<HttpEvent<any>> {
    const url = `${environment.serverUrl}/genie/journey/${journeyId}/uploadContentFile`;
    const fileblob = new Blob([file], {
      type: file.type,
    });
    const formData = new FormData();
    formData.append('file', file); // Ensure the file is appended correctly
  //  formData.append('purpose', 'assistants'); // Include any other necessary form data

    const updatedHeaders = this.getHeaders(headers);

    return this.http.post(url, formData, {
      headers: updatedHeaders,
      reportProgress: true,
      observe: 'events',
    });
  }
}

export interface IOpenAiFiles {
  object: string;
  id: string;
  purpose: string;
  filename: string;
  bytes: number;
  created_at: number;
  status: string;
  status_details: null;
  fileUrl?: string
}
